export const navigationLinks = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'About', path: '/about' },
  { label: 'Resources', path: '/resources' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contact', path: '/contact' },
];

export const legalLinks = [
  { label: 'Privacy Policy', path: '/privacy' },
  { label: 'Terms of Service', path: '/terms' },
  { label: 'Disclaimer', path: '/disclaimer' },
];

export const serviceList = [
  {
    slug: 'tax-credit-strategies',
    title: 'Tax Credit Strategies',
    summary:
      'Identify and claim non-controversial tax credits such as R&D, energy-efficiency, and Section 45L. We document the work so your CPA can feel comfortable filing.',
    bullets: [
      'R&D credits for service providers and SaaS teams',
      'Employee tax credit alternatives that avoid ERC mills',
      'Maintain full documentation for IRS defense',
    ],
    stats: 'Clients reduce effective tax rate by an average of 18%',
  },
  {
    slug: 'cost-segregation',
    title: 'Depreciation & Cost Segregation',
    summary:
      'Accelerate deductions by reclassifying building assets and claiming bonus depreciation across eligible components of your property portfolio.',
    bullets: [
      'Detailed engineering studies for commercial and mixed-use real estate',
      'Bonus depreciation strategies for multi-state owners',
      'Coordination with property tax advisors for alignment',
    ],
    stats: '$1.4M average first-year depreciation per property',
  },
  {
    slug: 'merps',
    title: 'MERPs & Reimbursement Plans',
    summary:
      'Build executive-friendly retirement plans such as MERPs, defined benefit, and 401(k) integration plans that deliver liquidity and tax control.',
    bullets: [
      'Customized MERP design + nondiscrimination testing',
      'Executive reimbursement plans aligned with cash flow',
      'Audit-ready documentation for ERISA compliance',
    ],
    stats: '94% plan approval rate with CPAs',
  },
  {
    slug: 'business-tax-planning',
    title: 'Multi-Entity Tax Optimization',
    summary:
      'We model entity structures for entrepreneurs with holdings across multiple LLCs, funds, and flow-through investments.',
    bullets: [
      'Entity stacking (RE, ops, advising) with tiered revenue recognition',
      'State apportionment optimization and nexus tracking',
      'Safe harbor checklists for consolidated tax positions',
    ],
    stats: 'Average annual cash tax reduction: 14%',
  },
];

export const adjacencyPages = [
  { label: 'Partners', path: '/partners' },
  { label: 'Free Assessment', path: '/free-assessment' },
  { label: 'Tax Scorecard', path: '/tax-scorecard' },
  { label: 'Schedule a Call', path: '/schedule-call' },
  { label: 'Success Stories', path: '/success-stories' },
  { label: 'For Advisors', path: '/for-advisors' },
  { label: 'Sitemap', path: '/sitemap' },
];

export const resources = [
  {
    title: '2026 High-Income Tax Playbook',
    type: 'Guide',
    description: 'Step-by-step instructions for credit stacking, depreciation acceleration, and advisory partnerships.',
    link: '/resources/high-income-guide',
  },
  {
    title: 'IRS Update Tracker',
    type: 'Blog',
    description: 'Monthly briefings on IRS rule changes that matter for high-income families and advisors.',
    link: '/resources/irs-updates',
  },
  {
    title: 'The Smart Money Edge Podcast',
    type: 'Podcast',
    description: 'Ed Lyon unpacks the IRS, audits, and how to defend multi-strategy tax plans.',
    link: '/resources/podcast',
  },
];

export const caseStudies = [
  {
    title: '25% reduction for multi-state services firm',
    summary: 'Stacked R&D credits with cost segregation to lower cash taxes while aligning with the firm’s CPA.',
    outcome: 'Saved $1.2M in 2025 federal and state liability.',
  },
  {
    title: 'MERP + reimbursement plan for PE-backed GP',
    summary: 'Custom MERP created for portfolio acquisitions, capturing tax-deductible contributions and cash flow alignment.',
    outcome: 'Unlocked $480K in additional deductible compensation.',
  },
  {
    title: 'Advisor partnership scale-up',
    summary: 'Built partner portal and co-branded content for Pfister Financial to refer clientele.',
    outcome: 'Three advisor partnerships closed within 90 days.',
  },
];

export const partnerFirms = [
  { name: 'Pfister Financial', description: 'Advisor partnership with private wealth teams.' },
  { name: 'Strategic Tax Partners', description: 'Integrates fractional CFOs with compliance-led tax planning.' },
  { name: 'Fidelity Investments', description: 'Works with business owners to align investment portfolios and tax posture.' },
];

export const leadFormFields = [
  { name: 'name', type: 'text', label: 'Full Name', required: true },
  { name: 'email', type: 'email', label: 'Email Address', required: true },
  { name: 'phone', type: 'tel', label: 'Phone Number', required: false },
  {
    name: 'income_band',
    type: 'select',
    label: 'Annual Income Range',
    required: true,
    options: ['Under $200k', '$200k-$500k', '$500k-$1M', 'Over $1M'],
  },
  {
    name: 'business_type',
    type: 'select',
    label: 'Business Structure',
    required: false,
    options: ['Sole Proprietor', 'LLC', 'S-Corp', 'C-Corp', 'Partnership', 'Other'],
  },
  {
    name: 'current_cpa',
    type: 'radio',
    label: 'Do you currently have a CPA?',
    required: true,
    options: ['Yes', 'No'],
  },
  {
    name: 'questions',
    type: 'textarea',
    label: 'Any specific tax concerns or questions?',
    placeholder: 'Tell us about your situation...',
    required: false,
  },
];
